import { Step } from '../Step';
import type { TRenderedStep } from 'shared/types/carousel';
import * as styles from './styles.css';
import { TDeviceType } from '@cian/ui-kit';
import clsx from 'clsx';

interface IStepsProps {
  steps: TRenderedStep[];
  device: TDeviceType;
}

export const Steps: React.FC<IStepsProps> = ({ steps, device }) => {
  return (
    <div className={clsx(styles['container'], styles[device])}>
      {steps.map(({ id, title, slides, slidesCount, banner }, index) => (
        <Step
          device={device}
          key={id}
          id={id}
          step={index + 1}
          title={title}
          slides={slides}
          slidesCount={slidesCount}
          isFirst={index === 0}
          banner={banner}
        />
      ))}
    </div>
  );
};
